import { render, staticRenderFns } from "./EmployeesModule.vue?vue&type=template&id=c68e5d8e&"
import script from "./EmployeesModule.vue?vue&type=script&lang=js&"
export * from "./EmployeesModule.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesModule.vue?vue&type=style&index=0&id=c68e5d8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports